module.exports = __webpack_public_path__ + "media/Gods&Monsters.91145882.wav";